module.exports = __webpack_public_path__ + "e7de4e7eb6857c47c195ca8fc3c078ba.gif";